import { useEffect, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./MetaMediaLibrary.scss";
import CloudinaryImageEditor from "../CloudinaryImageEditor";
import { getMediaLibrary } from "features/meta-travel-ads-campaign/Utils/getMediaLibrary";
import CustomButton from "components/Button";
import CustomButtonWithIconComponent from "components/CustomButtonWithIcon/Buttons";

const MetaMediaLibrary = ({ isOpen, onClose, hotelId, onSave, currentMarketingImage }) => {
  const [landscape, setLandscape] = useState([]);
  const [selectedImages, setSelectedImages] = useState({
    marketing_image: null,
  });

  useEffect(() => {
    if (isOpen) {
      setSelectedImages({ marketing_image: currentMarketingImage || null });
    }
  }, [isOpen, currentMarketingImage]);

  useEffect(() => {
    if(isOpen) {
      getMediaLibrary(hotelId).then((response) => {
        if (response.success) {
          const media = response.data?.media_lists || [];
          setLandscape(media.filter((item) => item.image_type === "marketing").map(i => i?.image_url));
        }
      });
    }
  },[isOpen])

  return (
    <>
      {isOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1100,
          }}
        />
      )}
      <Box className={`meta-slide-out-panel${isOpen ? " open" : ""}`}>
        <Box
          className="header"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box style={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={onClose} className="closeButton">
              <CloseIcon fontSize="small" />
            </IconButton>
            <Typography variant="body1" className="title">
              Media Library
            </Typography>
          </Box>
        </Box>
        <Box className="content">
          <Box display="flex" className="content-pmax-images">
            <CloudinaryImageEditor
              isEdit
              landscape={landscape}
              setLandscape={setLandscape}
              hotelId={hotelId}
              initialSelectedImage={currentMarketingImage}
              onChangeSelection={(key, url) => {
                setSelectedImages((prev) => ({
                  ...prev,
                  [`${key}_image`]: url,
                }));
              }}
            />
          </Box>
          <CustomButtonWithIconComponent
            color="#b0acac"
            hoverColor="#12794F"
            titleColor="#373F41"
            hoverTitleColor={"white"}
            height={"20px"}
            width="64px"
            borderRadius="20px"
            textStyle={{
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "center",
            }}
            variant="outlined"
            translate="no"
            onClick={() => {
              onSave(selectedImages);
              onClose();
            }}
          >
            Save
          </CustomButtonWithIconComponent>
        </Box>
      </Box>
    </>
  );
};

export default MetaMediaLibrary;
